export default __webpack_public_path__ + "static/media/icon-settings-dark.c74f0468.svg";